module.exports = __webpack_public_path__ + "img/opt_avsb_logo_with_text.ed808037.svg";